import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './CustomModal.css';
import { CustomModalType } from './types/CustomModalType';

/**
 * CustomModal Component
 * A premium modal component with backdrop blur, animations, and responsive handling.
 */
export const CustomModal: React.FC<CustomModalType> = ({
    isOpen,
    onClose,
    title,
    children,
    footer,
    size = 'medium',
    closeOnOverlayClick = true,
    showCloseButton = true,
    className = '',
}) => {
    // Prevent scrolling when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (closeOnOverlayClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleOverlayClick}>
            <div className={`custom-modal custom-modal--${size} ${className}`}>
                {(title || showCloseButton) && (
                    <div className="custom-modal__header">
                        {title && <h3 className="custom-modal__title">{title}</h3>}
                        {showCloseButton && (
                            <button className="custom-modal__close-btn" onClick={onClose} aria-label="Close modal">
                                <X size={20} />
                            </button>
                        )}
                    </div>
                )}
                
                <div className="custom-modal__body">
                    {children}
                </div>

                {footer && (
                    <div className="custom-modal__footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomModal;
